import { useLayoutEffect } from 'react';

type ScrollMode = 'allow' | 'lock';
type Ownership = { count: number; presentBeforeMount: boolean };
const owners = new WeakMap<HTMLElement, Map<string, Ownership>>();

/** Own a body class only while mounted; overlapping routes/overlays share it. */
export const useBodyScrollMode = (mode: ScrollMode) => {
  useLayoutEffect(() => {
    const body = document.body;
    const className = mode === 'allow' ? 'allow-overflow' : 'no-scroll';
    let classes = owners.get(body);
    if (!classes) {
      classes = new Map();
      owners.set(body, classes);
    }
    let ownership = classes.get(className);
    if (!ownership) {
      ownership = {
        count: 0,
        presentBeforeMount: body.classList.contains(className),
      };
      classes.set(className, ownership);
    }
    ownership.count += 1;
    body.classList.add(className);

    return () => {
      ownership.count -= 1;
      if (ownership.count === 0) {
        if (!ownership.presentBeforeMount) body.classList.remove(className);
        classes.delete(className);
        if (classes.size === 0) owners.delete(body);
      }
    };
  }, [mode]);
};
